<template lang="pug">
	.company-subscriptions
		ListView(name="mySubscriptions", :columnHidingEnabled="false", :pageSize="4", ref="mySubscriptions", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="r => r.Results", :getData="getMySubscriptions", :columns="mySubscriptionColumns")
			.flex-row.space-large.align-center(slot="left-actions")
				.font-big.upper {{$tCaption('Subscriptions')}}
				DxButton(icon="plus", @click="() => $refs.SubscriptionPopup.show(true)")
				Loader(v-if="isLoading", :text="$tCaption('Loading') + '...'")
			template(v-slot:settings-template="{ data }")
				DxMenu(v-if="data.Status !== 2", :dataSource="getMenuItems(data)", display-expr="name", @itemClick="(e) => onMenuItemClick(e, data)")
			template(v-slot:status-template="{ data }")
				.flex-row
					.status(:class="[getArrVal(billingStatus, data.Status, 'css')]", :title="data.Status === 0 ? $tCaption('The subscription is on hold awaiting payment.') : ''") {{getArrVal(billingStatus, data.Status)}}
			template(v-slot:payment-template="{ data }")
				.flex-row.space
					i(:class="[getArrVal(billingPaymentType, data.PaymentType, 'icon')]")
					span {{getArrVal(billingPaymentType, data.PaymentType)}}
			template(v-slot:products-template="{ data }")
				.flex-col.space(v-if="data && data.Purchases")
					.purchase.flex-col(v-for="purchase in data.Purchases")
						.flex-row.space.align-center
							i.fas.fa-circle.dot-point
							span {{purchase.Name}}
						.stations.flex-row.space(v-if="purchase.Stations && purchase.Stations.length")
							.font-small.grey(v-for="station in purchase.Stations") {{station.Name}}
		SelectSubscriptionPopup(ref="SubscriptionPopup" @reload-parent-page="$refs.mySubscriptions.reload()")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';
	import ListView from 'app-core/ListView.vue';
	import DxMenu from 'devextreme-vue/menu';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import {getArrVal, activateSubscription} from "app-core/helpers";
	import SelectSubscriptionPopup from "@/view/company/SelectSubscriptionPopup";
	import {BILLING_CYCLES, BILLING_DETAIL_STATUS, BILLING_PAYMENT_TYPE} from "app-core/constants";

	export default {
		translationCategory: 'company.Subscriptions',
		name: 'company-subscriptions',
		components: {SelectSubscriptionPopup, DxButton, DxCheckBox, ListView, DxMenu, Loader, Dropdown},
		watch: {
			'$locale.state.storedTranslations': {
				handler() {
					this.billingCycle = BILLING_CYCLES.toLocale('name', this);
					this.billingPaymentType = BILLING_PAYMENT_TYPE.toLocale('name', this);
					this.billingStatus = BILLING_DETAIL_STATUS.toLocale('name', this);
					if (__DEBUG__)
						console.log('watch.$locale.state.storedTranslations === >>> ', this.billingCycle);
				},
				immediate: true,
			},
		},
		data() {
			return {
				getArrVal,
				billingCycle: [],
				billingPaymentType: [],
				billingStatus: [],
				subscriptionStatusId: -1,
				menuActions: [
					{
						id: 'initialPayment',
						isForAutomatic: true,
						status: 3,
						name: () => this.$tCaption('Activate subscription'),
						icon: 'fas fa-money-check-alt'
					},
					{
						id: 'paymentSettings',
						isForAutomatic: true,
						status: 1,
						name: () => this.$tCaption('Payment settings'),
						icon: 'fas fa-money-check-alt'
					},
					{id: 'cancelSubscription', name: () => this.$tCaption('Cancel subscription'), icon: 'fas fa-times'},
				],
				isLoading: false,
				hasTrialEnd: false
			};
		},
		computed: {
			mySubscriptionColumns() {
				return [
					{dataField: 'Description', caption: () => this.$tCaption('Subscription')},
					{
						dataField: 'Amount',
						caption: () => this.$tCaption('Amount'),
						calculateCellValue: (row) => this.$formatCell(row, 'Amount', 'currency')
					},
					{dataField: 'NextBillDate', caption: () => this.$tCaption('Next bill date'), dataType: 'date'},
					...(this.hasTrialEnd ? [{dataField: 'TrialEndDate', caption: () => this.$tCaption('Trial end date'), dataType: 'date'}] : []),
					{dataField: 'PaymentDays', caption: () => this.$tCaption('Payment days')},
					{
						dataField: 'BillingCycle',
						caption: () => this.$tCaption('Billing cycle'),
						lookup: {dataSource: () => this.billingCycle, displayExpr: 'name', valueExpr: 'id'},
					},
					{
						dataField: 'PaymentType',
						caption: () => this.$tCaption('Payment type'),
						lookup: {dataSource: () => this.billingPaymentType, displayExpr: 'name', valueExpr: 'id'},
						cellTemplate: 'payment-template'
					},
					{
						dataField: 'Status',
						caption: () => this.$tCaption('Subscription status'),
						lookup: {dataSource: () => this.billingStatus, displayExpr: 'name', valueExpr: 'id'},
						cellTemplate: 'status-template'
					},
					{dataField: 'ProductNames', caption: () => this.$tCaption('Products'), cellTemplate: 'products-template',},
					{
						dataField: 'Description',
						name: 'Description1',
						caption: ' ',
						cellTemplate: 'settings-template',
						width: '80px'
					},
				];
			}
		},
		mounted() {
			if (__DEBUG__)
				window.subscriptions = this;
		},
		methods: {
			getMenuItems(data) {
				return [{
					icon: 'fas fa-ellipsis-v',
					items: [
						...this.menuActions.filter(f => (data.PaymentType === 0 || !f.isForAutomatic) && (f.status === void 0 || f.status === data.Status))
					]
				}];
			},
			onMenuItemClick(e, data) {
				if (__DEBUG__)
					console.debug('On menu item click', {e, data});
				var subscriptionId = data.Oid;
				switch (e.itemData.id) {
					case 'cancelSubscription':
						this.$confirmMessage({
							title: this.$tCaption('Confirm action', '@actions'),
							text: this.$tCaption('Are you sure you want to cancel subscription?'),
							handler: () => {
								this.$Data.getExternalApi('CustomerSubscription/CancelSubscription', `subscriptionId=${subscriptionId}`).then(r => {
									if (r.Success) {
										this.$notifySuccess(this.$tCaption('Subscription has been successfully canceled'));
										this.$refs.mySubscriptions.reload();
									} else {
										this.$notifyError(r.ErrorMessage);
									}
								})
							}
						});
						break;
					case 'paymentSettings':
						this.isLoading = true;
						this.$Data.getExternalApi('CustomerSubscription/GetCustomerPortalUrl', `returnUrl=${encodeURIComponent(window.location.href)}`).then(r => {
							window.location.href = r;
						}).finally(() => this.isLoading = false);
						break;
					case 'initialPayment':
						this.activateSubscription(subscriptionId);
						break;
				}
			},
			activateSubscription(subscriptionId) {
				this.isLoading = true;
				activateSubscription(subscriptionId).catch(() => {
					this.$refs.SubscriptionPopup.show(false);
				}).finally(() => {
					this.isLoading = false;
				});
			},
			getMySubscriptions(a, b, c) {
				return this.$Data.getMySubscriptions(a, b, c, this.subscriptionStatusId).then(r => ({
					...r,
					Results: r.Results.map(f => ({
						...f
					}))
				})).then(r => {
					this.hasTrialEnd = (r.Results || []).some(f => f.TrialEndDate);
					return r;
				});
			},
		}
	};
</script>

<style lang="scss">
	.dot-point {
		font-size: 6px;
	}
</style>